import {
  Directive,
  Input,
  OnInit,
  OnDestroy,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Subscription, combineLatest } from 'rxjs';
import { ConfigService } from '../service/config.service';
import { SessionService } from '../service/session.service';

@Directive({
  selector: '[appPortalLoginRequired]',
  standalone: true,
})
export class PortalLoginRequiredDirective implements OnInit, OnDestroy {
  @Input() showButton: boolean = false;

  private stateSubscription?: Subscription;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private configService: ConfigService,
    private sessionService: SessionService,
  ) {}

  ngOnInit() {
    this.stateSubscription = combineLatest([
      this.configService.getConfig$(),
      this.sessionService.isAuthenticated$(),
    ]).subscribe(([config, authenticated]) => {
      this.updateView(config, authenticated);
    });
  }

  ngOnDestroy() {
    if (this.stateSubscription) {
      this.stateSubscription.unsubscribe();
    }
  }

  private updateView(config: any, authenticated: boolean) {
    this.viewContainer.clear();

    const requiresLoginValue = config?.invoiceSubmissionRequiresLogin;
    const requiresLogin =
      requiresLoginValue !== null &&
      requiresLoginValue !== undefined &&
      requiresLoginValue.toString().toLowerCase() === 'true';

    const shouldShow = this.showButton
      ? authenticated || !requiresLogin
      : !authenticated && requiresLogin;

    if (shouldShow) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
